import ticketIcon from "@/assets/icons/ticket.svg";
import type { Goal } from "@/interfaces/goal";

function GoalBar({ goal, tickets }: { goal: Goal; tickets: number }) {
  const target = goal.item.price;
  const progress = target > 0 ? Math.min(Math.max(tickets / target, 0), 1) : 1;
  const complete = progress >= 1;
  const remaining = Math.max(target - tickets, 0);

  return (
    <div className="flex flex-col">
      <div className="relative flex items-center">
        {/* Start node */}
        <div className="border-line bg-goldenrod relative z-10 h-14 w-14 shrink-0 rounded-full border-2" />

        {/* Track */}
        <div className="border-line bg-surface-alt relative -mx-3 h-5 flex-1 overflow-hidden rounded-full border-2">
          <div
            className="bg-goldenrod absolute inset-y-0 left-0 transition-[width] duration-500"
            style={{ width: `${progress * 100}%` }}
          />
        </div>

        {/* End node - shows the item image on top of the circle */}
        <div
          className={`relative z-10 flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-full border-2 transition-colors ${
            complete ? "border-goldenrod bg-surface" : "border-line bg-surface"
          }`}
        >
          {goal.item.image ? (
            <img
              src={goal.item.image}
              alt={goal.item.name}
              className="h-full w-full object-contain p-1.5"
            />
          ) : (
            <img src={ticketIcon} alt="" className="h-7 w-7" />
          )}
        </div>
      </div>

      {/* Pull the caption up toward the track - the 64px end circles overhang
          the 20px bar, leaving dead space we don't want between bar and text. */}
      <p className="text-body text-ink-muted mt-2 text-center">
        {complete ? (
          <>
            You can grab the <span className="font-bold">{goal.item.name}</span>
            !
          </>
        ) : (
          <>
            <span className="font-bold">{remaining}</span> more ticket
            {remaining === 1 ? "" : "s"} until the{" "}
            <span className="font-bold">{goal.item.name}</span>
          </>
        )}
      </p>
    </div>
  );
}

export default function LoggedHours({
  tickets,
  goals,
}: {
  tickets: number;
  goals: Goal[];
}) {
  return (
    <div className="flex w-full flex-col gap-10">
      {goals.length > 0 && (
        <div className="flex flex-col gap-8">
          {goals.map((goal) => (
            <GoalBar key={goal.id} goal={goal} tickets={tickets} />
          ))}
        </div>
      )}
    </div>
  );
}
